import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {DayOffOutput} from "../../generated";
import {useStore} from "../../context";
import ResourceGridView from "../../components/grid/ResourceGridView";
import {DaysOffEmployeeStore} from "./days-off-employee-store";
import {formatDayOffReasonEnum} from "../daysOffManage/format-day-off-reason-enum";
import {DayOffEmployeeAskModal} from "./day-off-employee-ask-modal";
import {dateTimeCell} from "../../components/ui/cells";

export const DayOffEmployeeList = observer(() => {
    const {uiBus} = useStore()
    const [store] = useState(() => new DaysOffEmployeeStore(uiBus));

    return <div className={'dashboard'}>
        <ResourceGridView<DayOffOutput>
            gridResource={store}
            onCreate={() => {
                store.openModal();
            }}
            onCreateLabel={'Request'}
            columns={[
                'id',
                {
                    name: 'Date',
                    value: entity => dateTimeCell(entity.date),
                },
                {
                    name: 'Status',
                    value: entity => (entity.status),
                },
                {
                    name: 'Reason',
                    value: entity => formatDayOffReasonEnum(entity.reason)
                }
            ]}
        />
        {store.isNewDayOffModalOpen && <DayOffEmployeeAskModal store={store}/>}
    </div>
})
